import { MixedTags } from '@yaireo/tagify/dist/react.tagify';

import DropdownItem from './dropdown_item';
import Tag from './tag';

import './styles.scss';

export const Tagify = MixedTags;

export const settings = {
  duplicates: true,
  enforceWhitelist: true,
  onChangeAfterBlur: false,

  hooks: {
    suggestionClick(e, { tagData } = {}) {
      if (tagData?.disabled) {
        e.preventDefault();
        return new Promise(() => {});
      }
      return Promise.resolve();
    },
  },

  dropdown: {
    classname: 'deal-tagged-body-input-tag-dropdown shadow-lg overflow-visible',
    highlightFirst: true,
    includeSelectedTags: true,
    maxItems: 100,
    searchKeys: ['email', 'name', 'value'],

    // Min number of characters after an @ before showing dropdown, zero shows immediately
    enabled: 0,

    // Sorting items by type is required for group header rendering to work correctly
    // Unknown types should be at the end so they are not the default selection
    sortby(items) {
      return items.sort((a, b) => {
        if (a.type !== b.type) {
          if (!a.type) return 1;
          if (!b.type) return -1;
          return a.type < b.type ? 1 : -1;
        }
        if (a.disabled !== b.disabled) {
          return a.disabled ? 1 : -1;
        }
        return 0;
      });
    },
  },

  templates: {
    dropdownItem: DropdownItem,
    dropdownFooter: () => '',
    tag: Tag,
  },
};
